import { useState } from "react";
import { BrandLogo } from "@/components/BrandLogo";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(token ? "" : "This reset link is missing its code. Request a new one.");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) { setError(errorText(err)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 court-grain" data-testid="reset-page">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 fade-up" data-testid="reset-form">
        <BrandLogo />
        <h1 className="font-display text-4xl font-extrabold uppercase">New password</h1>
        {done ? (
          <p className="text-sm text-emerald-300 rounded-md border border-emerald-500/40 bg-emerald-950/30 p-3" data-testid="reset-done">
            Your password has been changed. You can sign in with it now.
          </p>
        ) : (
          <>
            <Input data-testid="reset-password-input" type="password" placeholder="New password (min 8 characters)" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} autoComplete="new-password" className="h-11 bg-slate-900/70" disabled={!token} />
            <Input data-testid="reset-confirm-input" type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" className="h-11 bg-slate-900/70" disabled={!token} />
            {error && <p data-testid="reset-error" className="text-sm text-rose-400">{error}</p>}
            <Button data-testid="reset-submit-btn" type="submit" disabled={busy || !token} className="w-full h-11 bg-blue-600 hover:bg-blue-500 font-semibold">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save new password"}
            </Button>
          </>
        )}
        <Link to="/login" data-testid="reset-login-link" className="block text-sm font-semibold text-blue-400 hover:text-blue-300">Go to sign in</Link>
      </form>
    </div>
  );
}
